import { render, staticRenderFns } from "./EditRoute.vue?vue&type=template&id=2c5b0e8a&scoped=true"
import script from "./EditRoute.vue?vue&type=script&lang=js"
export * from "./EditRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5b0e8a",
  null
  
)

export default component.exports